// Utilities
import { slugify } from 'Utils'

const getCardTitleSlug = (title) => {
  return slugify(title)
}

const getCardStatusActivityIcon = (title) => {
  const status = [
    {
      names: ['paused', 'pausado'],
      icon: 'far fa-pause-circle',
    },

    {
      names: ['activated', 'activado'],
      icon: 'far fa-play-circle',
    },

    {
      names: ['completed', 'completado'],
      icon: 'fas fa-flag-checkered',
    },
  ]

  let icon = ''
  for (let current of status) {
    if (current.names.some((name) => title.includes(name))) icon = current.icon
  }

  return icon
}

export { getCardTitleSlug, getCardStatusActivityIcon }
